(function () {

    'use strict';

    angular.module('iplusjs.integration.pkslogin', [
        'iplusjs.config',
        'iplusjs.authentication',
        'iplusjs.integration',
        'iplusjs.utils.html',
        'iplusjs.utils.misc',
        'mm.foundation.modal',
        'lodash',
        'modernizr'
    ])
        .component('iplusjsPksLogin', {
            bindings: {
                visible: '<iplVisible',
                options: '<iplOptions'
            },
            templateUrl: 'common/integration/pksLogin.html',
            controller: PksLoginController,
            controllerAs: 'pksVm'
        });

    PksLoginController.$inject = [
        '$rootScope',
        '$timeout',
        '$window',
        '$modal',
        'lodash',
        'modernizr',
        'AppConfig',
        'IntegrationService',
        'AuthenticationService',
        'MiscUtilsService'
    ];

    function PksLoginController($rootScope, $timeout, $window, $modal, _, modernizr, AppConfig, IntegrationService, AuthenticationService, MiscUtilsService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onDestroy = onDestroy;
        vm.onKeydown = onKeydown;
        vm.login = login;
        vm.isLoggedIn = isLoggedIn;
        vm.isVisible = isVisible;

        function onInit() {
            activate();
            resetSessionStorage();
        }

        function onDestroy() {
            resetSessionStorage();
        }

        function activate() {
            IntegrationService.setIntegrationParams({
                loginDialog: false
            });

            vm.options = vm.options || {};
            vm.hideReloadAnonymMessage = false;
            vm.isAppModus = MiscUtilsService.isAppModus();
            vm.integrationParamHidePksLogin = IntegrationService.getIntegrationParams().hidePksLogin;
            IntegrationService.setIntegrationParams({
                hidePksLogin: false,
                reload: false
            });

            $rootScope.$on('iplusjs:openLoginDialog', function (event, alert) {
                var modalKundenportalLogin = $modal.open({
                    templateUrl: 'modal/modalKundenportalLogin.html',
                    windowClass: 'medium',
                    controller: 'ModalKundenportalLoginController',
                    controllerAs: 'modalVm'
                });

                modalKundenportalLogin.result.then(function (action) {
                    login();
                }).catch(function (error) {
                });
            });
        }

        function onKeydown(event) {
            if (event && event.keyCode === 13) {
                event.preventDefault();

                login();
            }
        }

        function login() {
            if (modernizr.sessionstorage) {
                if (_.get(vm.options, 'sessionStorage')) {
                    _.forOwn(_.get(vm.options, 'sessionStorage'), function (val, key) {
                        $window.sessionStorage.setItem(key, val);
                    });
                }
            }

            if (AppConfig.INTEGRATION.loginPage) {
                IntegrationService.setIntegrationParams({
                    historyBackAllowed: true
                });

                $window.confirmBeforeUnload = false;
                $window.removePksRedirectInfos = false;

                $timeout(function () {
                    $window.location.href = AppConfig.INTEGRATION.loginPage;
                }, 150);
            }
        }

        function isLoggedIn() {
            return (
                AuthenticationService.getSession().tokenLoginSession ||
                IntegrationService.getIntegrationParams().isTokenLogin
            );
        }

        function isVisible() {
            return (
                vm.visible &&
                vm.integrationParamHidePksLogin !== true &&
                !vm.isAppModus
            );
        }

        function resetSessionStorage() {
            if (modernizr.sessionstorage) {
                if (_.get(vm.options, 'sessionStorage')) {
                    _.forOwn(_.get(vm.options, 'sessionStorage'), function (val, key) {
                        $window.sessionStorage.removeItem(key);
                    });
                }
            }
        }
    }

})();
